import axios from 'axios';
import Cookie from 'cookies-js';
import toastr from 'toastr';
import jwt from 'jsonwebtoken';

import config from '../../config/index';
import routes from '../../constants/routes';
import {
  UPLOAD_PROFILE_PHOTO,
  UPLOAD_PROFILE_PHOTO_ERROR,
  UPLOAD_PROFILE_PHOTO_IS_LOADING,
  DELETE_UPLOAD_PROFILE_PHOTO_ERROR,
} from '../types';
import logoutAction from '../auth.actions/logout.action';

const postProfilePic = profilePhoto => ({
  type: UPLOAD_PROFILE_PHOTO,
  profilePhoto
});

const postProfilePicError = error => ({
  type: UPLOAD_PROFILE_PHOTO_ERROR,
  error
});

const isLoading = () => ({
  type: UPLOAD_PROFILE_PHOTO_IS_LOADING
});

export const deleteProfilePicError = () => ({
  type: DELETE_UPLOAD_PROFILE_PHOTO_ERROR
});

const uploadProfilePhoto = photoDetails => (dispatch) => {
  dispatch(isLoading());
  const token = Cookie.get('jwtToken');
  const decodeToken = jwt.decode(token);
  const { customerId } = decodeToken;
  const mainObj = {
    ...photoDetails,
    customerId
  };

  return axios.post(`${config.apiUrl}${routes.UPLOADPROFILEPIC}`, mainObj, {
    headers: { Authorization: `Bearer ${token}` }
  }).then((response) => {
    dispatch(isLoading());
    const { data } = response;
    if (data.isSuccessful) {
      dispatch(postProfilePic(data))
      toastr.success(data.responseMessage);
    } else {
      dispatch(postProfilePicError(data.responseMessage))
    }
  }).catch((error) => {
    dispatch(isLoading());
    if (error.response === undefined) {
      window.location.href = '/error';
    }
    if (error.response.status === 401) {
      const { status } = error.response;
      dispatch(logoutAction(status));
    }
    const { data } = error.response;
    dispatch(postProfilePicError(data.responseMessage));
    toastr.error(data.responseMessage);
    throw error;
  });
};

export default uploadProfilePhoto;
